import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { createContext, memo, useCallback, useContext } from 'react';
import { useAppDispatch } from '../redux';
import { actions } from '../redux/slices/page';
import { usePageContext } from './page';
export const BlockContext = createContext(undefined);
export const SectionBlockContext = createContext(undefined);
export const JaenSectionBlockProvider = memo(({ path, id, position, Component }) => {
    const { jaenPage } = usePageContext();
    const dispatch = useAppDispatch();
    const register = useCallback((props) => {
        dispatch(actions.section_register({
            pageId: jaenPage.id,
            path,
            props
        }));
    }, [dispatch, jaenPage.id]);
    return (_jsx(SectionBlockContext.Provider, { value: {
            path,
            id,
            position,
            Component,
            register
        }, children: Component ? (_jsx(Component, {})) : (_jsxs(Text, { children: ["No block component found for section ", id, " at path", ' ', path
                    .map(step => step.sectionId
                    ? `${step.fieldName}[${step.sectionId}]`
                    : step.fieldName)
                    .join(' / '), ". Please contact the site administrator."] })) }));
});
export const useSectionBlockContext = () => {
    const context = useContext(SectionBlockContext);
    return context;
};
